import { useTranslation } from 'react-i18next';

interface DeferredBookingStatusBadgeProps {
  readonly status: string;
}

const STATUS_STYLES: Record<string, string> = {
  PENDING_OWNER_CONFIRMATION: 'bg-amber-100 text-amber-700',
  AWAITING_GUEST_PAYMENT: 'bg-blue-100 text-blue-700',
  REJECTED: 'bg-red-100 text-red-700',
};

export const DeferredBookingStatusBadge = ({ status }: DeferredBookingStatusBadgeProps) => {
  const { t } = useTranslation('badges');

  const STATUS_LABELS: Record<string, string> = {
    PENDING_OWNER_CONFIRMATION: t('statusPendingOwnerConfirmation'),
    AWAITING_GUEST_PAYMENT: t('statusAwaitingGuestPayment'),
    REJECTED: t('statusRejected'),
  };

  const classes = STATUS_STYLES[status] ?? 'bg-gray-100 text-gray-600';
  const label = STATUS_LABELS[status] ?? status;

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${classes}`}>
      {label}
    </span>
  );
};
